import { render } from "./Index.vue?vue&type=template&id=aeee9900&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=aeee9900&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aeee9900"

export default script